// The attributes every registry search reports, whichever surface ran it, so
// the driver app and the dashboard read on one funnel.

import { parseDotNumberQuery } from './dotNumberQuery'

export interface SearchOutcome {
  query: string
  resultsCount: number
  /** The query as the server searched it; null when it did not say. */
  normalizedQuery?: string | null
  /** The query was read as a DOT number and looked up by it. */
  dotLookup?: boolean
}

/** Where the user was when they left the registry. */
export interface LeftRegistry extends SearchOutcome {
  /** A search had answered — every manual entry should say true after the gate. */
  searchedBeforeManual: boolean
}

export const dotLookupOf = (outcome: SearchOutcome): boolean =>
  outcome.dotLookup ?? parseDotNumberQuery(outcome.query) !== null

export const searchResultsAttributes = (outcome: SearchOutcome) => ({
  search_term: outcome.query,
  results_count: outcome.resultsCount,
  has_results: outcome.resultsCount > 0,
  search_type: dotLookupOf(outcome) ? 'dot_number' : 'company_name',
  normalized_query: outcome.normalizedQuery ?? null,
  dot_lookup: dotLookupOf(outcome),
})

/** What every way out of the registry reports, so before/after compare. */
export const leftRegistryAttributes = (params: LeftRegistry) => ({
  search_term: params.query,
  results_count: params.resultsCount,
  // Typing past a list of matches is a different signal from typing
  // because nothing was found
  had_results: params.resultsCount > 0,
  searched_before_manual: params.searchedBeforeManual,
  normalized_query: params.normalizedQuery ?? null,
  dot_lookup: dotLookupOf(params),
})

export const searchAbandonedAttributes = (search: {
  query: string
  resultsCount: number
}) => ({
  search_term: search.query,
  results_count: search.resultsCount,
  had_results: search.resultsCount > 0,
})

export const carrierSelectedAttributes = (params: {
  rank: number
  dotNumber?: string | null
}) => ({
  selected_rank: params.rank,
  dot_number: params.dotNumber ?? null,
})
